/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FilterPlaceholderCustomersRequest} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'
import {FilterPlaceholderCustomersResponse} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'


export const filterPlaceholderCustomers = (request:FilterPlaceholderCustomersRequest, options?: CashRequestOptions) => post<FilterPlaceholderCustomersRequest, FilterPlaceholderCustomersResponse>("/2.0/cash/filter-placeholder-customers", request, {...options, rejectOnError: true })